(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $03ec5ca610486646$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"4ko55":"index.4c293e6a.js","hOerA":"icons.c14567a0.svg"}'));

// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
var $21b983287c82ebd3$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $21b983287c82ebd3$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $21b983287c82ebd3$exports));
try {
    regeneratorRuntime = $21b983287c82ebd3$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $21b983287c82ebd3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($21b983287c82ebd3$var$runtime);
}


const $a536fbf06af412b5$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes";
const $a536fbf06af412b5$export$196440f71ed9f601 = 20;
const $a536fbf06af412b5$export$5feaddb1377b7f5e = 5;
const $a536fbf06af412b5$export$7167c830cefcb6b5 = "1abccb16-ff74-471c-9c20-7f67aa7461e1";
const $a536fbf06af412b5$export$3ce8858248d89a69 = 2.5;



const $77eae7726dbdfc03$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $77eae7726dbdfc03$export$2b3ff41fecbef7c8 = async function(url, dataUpload) {
    try {
        const fetchPro = dataUpload ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataUpload)
        }) : fetch(url);
        const res = await Promise.race([
            fetchPro,
            $77eae7726dbdfc03$var$timeout((0, $a536fbf06af412b5$export$196440f71ed9f601))
        ]);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} ${res.status}`);
        return data;
    } catch (err) {
        throw err;
    }
}; // export const getJson = async function(url) {
 //   try {
 //
 //     const res = await Promise.race([fetch(url), timeout(TIMEOUT_SEC)]);
 //     const data = await res.json();
 //
 //     if (!res.ok) throw new Error(`${data.message} ${res.status}`);
 //     return data;
 //   } catch (err) {
 //     throw err;
 //   }
 // };
 //
 // export const sendJson = async function(url, dataUpload) {
 //   try {
 //     const fetchPro = fetch(url, {
 //       method: 'POST',
 //       headers: {
 //         'Content-Type': 'application/json'
 //       },
 //       body: JSON.stringify(dataUpload)
 //     });
 //     const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);
 //     const data = await res.json();
 //
 //     if (!res.ok) throw new Error(`${data.message} ${res.status}`);
 //     return data;
 //   } catch (err) {
 //     throw err;
 //   }
 // };


const $0bc36518f6cf0450$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        resultsPerPage: (0, $a536fbf06af412b5$export$5feaddb1377b7f5e),
        page: 1
    },
    bookmarks: []
};
const $0bc36518f6cf0450$var$createRecipeObject = function(data) {
    const { recipe: recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0bc36518f6cf0450$export$b96725c7a035d60b = async function(id) {
    try {
        const data = await (0, $77eae7726dbdfc03$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}/${id}?key=${(0, $a536fbf06af412b5$export$7167c830cefcb6b5)}`);
        $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe = $0bc36518f6cf0450$var$createRecipeObject(data);
        if ($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id)) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = false;
        console.log($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        console.error(`${err} 😂😂😂`);
        throw err;
    }
};
const $0bc36518f6cf0450$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $0bc36518f6cf0450$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $77eae7726dbdfc03$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}?search=${query}&key=${(0, $a536fbf06af412b5$export$7167c830cefcb6b5)}`);
        // console.log(data);
        $0bc36518f6cf0450$export$ca000e230c0caa3e.search.results = data.data.recipes.map((req)=>{
            return {
                id: req.id,
                title: req.title,
                publisher: req.publisher,
                image: req.image_url,
                ...req.key && {
                    key: req.key
                }
            };
        });
        $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page = 1;
    } catch (err) {
        console.log(`${err} 😁😁😁`);
        throw Error;
    }
};
const $0bc36518f6cf0450$export$8c2e2ac0b8a4e1c4 = function(page = $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page) {
    $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0bc36518f6cf0450$export$ca000e230c0caa3e.search.resultsPerPage; // 0
    const end = page * $0bc36518f6cf0450$export$ca000e230c0caa3e.search.resultsPerPage; // 9
    return $0bc36518f6cf0450$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0bc36518f6cf0450$export$43630f7a3a617b54 = function(newServings) {
    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.servings;
    // newQT = OldQT * newServings / oldServings // 2 * 8 / 4 = 4
    });
    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.servings = newServings;
};
const $0bc36518f6cf0450$var$persistBookmarks = function() {
    localStorage.setItem("bookmarks", JSON.stringify($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks));
};
const $0bc36518f6cf0450$export$72009cc673d27d80 = function(recipe) {
    // Add Bookmark
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // Mark current recipe as a bookmark
    if (recipe.id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0bc36518f6cf0450$var$persistBookmarks();
};
const $0bc36518f6cf0450$export$2db69b245b3902c8 = function(id) {
    // Delete Bookmark
    const index = $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // Mark current recipe as NOT a bookmarked
    if (id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0bc36518f6cf0450$var$persistBookmarks();
};
const $0bc36518f6cf0450$var$init = function() {
    const storage = localStorage.getItem("bookmarks");
    if (storage) $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$0bc36518f6cf0450$var$init();
const $0bc36518f6cf0450$var$clearBookmarks = function() {
    localStorage.clear("bookmarks");
};
const $0bc36518f6cf0450$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "").map((ing)=>{
            const ingArr = ing[1].split(",").map((el)=>el.trim());
            // const ingArr = ing[1].replaceAll(' ', '').split(',');
            if (ingArr.length !== 3) throw new Error("not correct Form of INGRIDIENTS!");
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            publisher: newRecipe.publisher,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            servings: +newRecipe.servings,
            cooking_time: +newRecipe.cookingTime,
            ingredients: ingredients
        };
        const data = await (0, $77eae7726dbdfc03$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}?key=${(0, $a536fbf06af412b5$export$7167c830cefcb6b5)}`, recipe);
        $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe = $0bc36518f6cf0450$var$createRecipeObject(data);
        $0bc36518f6cf0450$export$72009cc673d27d80($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
};


var $1fdba731d27b481b$exports = {};


$1fdba731d27b481b$exports = (parcelRequire("aNJCr")).getBundleURL("4ko55") + (parcelRequire("iE7OH")).resolve("hOerA");


class $c732e9e6223e19d8$export$2e2bcd8739ae039 {
    _data;
    render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDom = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDom.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // console.log(newEl.isEqualNode(curEl));
            // Updates Changed Text
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            // Updates Changed Attributes
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    renderSpinner() {
        const markUP = `
        <div class="spinner">
            <svg>
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports)))}#icon-loader"></use>
            </svg>
        </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markUP);
    }
    renderError(message = this._errorMessage) {
        const markup = `
          <div class="error">
              <div>
                  <svg>
                    <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports)))}#icon-alert-triangle"></use>
                  </svg>
              </div>
              <p>${message}<p>
          </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `
          <div class="message">
              <div>
                  <svg>
                    <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports)))}#icon-smile"></use>
                  </svg>
              </div>
              <p>${message}<p>
          </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}



var $b0f2bd7507f92d39$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$b0f2bd7507f92d39$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $b0f2bd7507f92d39$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $b0f2bd7507f92d39$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $b0f2bd7507f92d39$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $b0f2bd7507f92d39$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $b0f2bd7507f92d39$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $b0f2bd7507f92d39$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


class $95a7d6c4a0a50ae1$var$RecipeView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".recipe");
    _errorMessage = "We could not find recipe. Try again...";
    _message = "";
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--update-servings");
            if (!btn) return;
            const { updateTo: updateTo } = btn.dataset;
            if (+updateTo > 0) handler(+updateTo);
        });
    }
    addHandlerBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        return `
        <figure class='recipe__fig'>
              <img src='${this._data.image}' alt='${this._data.title}' class='recipe__img' />
              <h1 class='recipe__title'>
                <span>${this._data.title}</span>
              </h1>
            </figure>
    
            <div class='recipe__details'>
              <div class='recipe__info'>
                <svg class='recipe__info-icon'>
                  <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-clock'></use>
                </svg>
                <span class='recipe__info-data recipe__info-data--minutes'>${this._data.cookingTime}</span>
                <span class='recipe__info-text'>minutes</span>
              </div>
              <div class='recipe__info'>
                <svg class='recipe__info-icon'>
                  <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-users'></use>
                </svg>
                <span class='recipe__info-data recipe__info-data--people'>${this._data.servings}</span>
                <span class='recipe__info-text'>servings</span>
    
                <div class='recipe__info-buttons'>
                  <button class='btn--tiny btn--update-servings' data-update-to="${this._data.servings - 1}" >
                    <svg>
                      <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-minus-circle'></use>
                    </svg>
                  </button>
                  <button class='btn--tiny btn--update-servings' data-update-to="${this._data.servings + 1}">
                    <svg>
                      <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-plus-circle'></use>
                    </svg>
                  </button>
                </div>
              </div>
    
              <div class='recipe__user-generated ${this._data.key ? "" : "hidden"}'>
                <svg>
                  <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-user'></use>
                </svg>
              </div>
               
              <button class='btn--round btn--bookmark'>
                <svg class=''>
                  <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}'></use>
                </svg>
              </button>
            </div>
    
            <div class='recipe__ingredients'>
              <h2 class='heading--2'>Recipe ingredients</h2>
              <ul class='recipe__ingredient-list'>
                ${this._data.ingredients.map(this._generateMarkupIngredient).join("")}
                </ul>
            </div>
    
            <div class='recipe__directions'>
              <h2 class='heading--2'>How to cook it</h2>
              <p class='recipe__directions-text'>
                This recipe was carefully designed and tested by
                <span class='recipe__publisher'>${this._data.publisher}</span>. Please check out
                directions at their website.
              </p>
              <a
                class='btn--small recipe__btn'
                href='${this._data.sourceUrl}'
                target='_blank'
              >
                <span>Directions</span>
                <svg class='search__icon'>
                  <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-arrow-right'></use>
                </svg>
              </a>
            </div>
    `;
    }
    _generateMarkupIngredient(ing) {
        return `
                    <li class='recipe__ingredient'>
                      <svg class='recipe__icon'>
                        <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-check'></use>
                      </svg>
                      <div class='recipe__quantity'>${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($b0f2bd7507f92d39$exports)))(ing.quantity).toString() : ""}
                      </div>
                      <div class='recipe__description'>
                        <span class='recipe__unit'>${ing.unit}</span>
                        ${ing.description}
                      </div>
                    </li>
                      `;
    }
}
var $95a7d6c4a0a50ae1$export$2e2bcd8739ae039 = new $95a7d6c4a0a50ae1$var$RecipeView();


class $8d9571d82bdb9304$var$SearchView {
    _parentEl = document.querySelector(".search");
    getQuery() {
        const query = this._parentEl.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    _clearInput() {
        this._parentEl.querySelector(".search__field").value = "";
    }
    addHandlerSearch(handler) {
        this._parentEl.addEventListener("submit", function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $8d9571d82bdb9304$export$2e2bcd8739ae039 = new $8d9571d82bdb9304$var$SearchView();






class $d511a9d636491df2$var$previewView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
           <li class='preview'>
                  <a class='preview__link ${this._data.id === id ? "preview__link--active" : ""}' href='#${this._data.id}'>
                    <figure class='preview__fig'>
                      <img src='${this._data.image}' alt='${this._data.title}' />
                    </figure>
                    <div class='preview__data'>
                        <h4 class='preview__title'>${this._data.title}</h4>
                        <p class='preview__publisher'>${this._data.publisher}</p>
                        
                        <div class='recipe__user-generated ${this._data.key ? "" : "hidden"}'>
                          <svg>
                            <use href='${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-user'></use>
                          </svg>
                        </div>
                    </div>
                  </a>
            </li>
      `;
    }
}
var $d511a9d636491df2$export$2e2bcd8739ae039 = new $d511a9d636491df2$var$previewView();


class $99e6646170dcffc3$var$ResultsView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipe found!!!";
    _message = "";
    _generateMarkup() {
        return this._data.map((result)=>(0, $d511a9d636491df2$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var $99e6646170dcffc3$export$2e2bcd8739ae039 = new $99e6646170dcffc3$var$ResultsView();





class $6346fa8b18afb025$var$bookmarkView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = "No bookmarks yet. Find a nice recipe and bookmark it :)";
    _message = "";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((bookmark)=>(0, $d511a9d636491df2$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
}
var $6346fa8b18afb025$export$2e2bcd8739ae039 = new $6346fa8b18afb025$var$bookmarkView();




class $da53bbe9f60c4332$var$addRecipeView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".upload");
    _message = "You added a recipe! Vamuuuus ...";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnClose = document.querySelector(".btn--close-modal");
    _btnOpen = document.querySelector(".nav__btn--add-recipe");
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
        this.addHandlerUpload();
    }
    toggleWindow() {
        this._window.classList.toggle("hidden");
        this._overlay.classList.toggle("hidden");
    }
    _addHandlerShowWindow() {
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
    }
    addHandlerUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArray = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArray);
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $da53bbe9f60c4332$export$2e2bcd8739ae039 = new $da53bbe9f60c4332$var$addRecipeView();




class $f03ebf78cca01ded$var$PaginationView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    addHandlerRender(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generatePrev() {
        return `
    <button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
              <svg class="search__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-arrow-left"></use>
              </svg>
              <span>Page ${curPage - 1}</span>
        </button>
    `;
    }
    _generateMarkup() {
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        const curPage1 = this._data.page;
        // Page 1 , there are other Pages
        if (curPage1 === 1 && numPages > 1) return `
          <button data-goto="${curPage1 + 1}" class="btn--inline pagination__btn--next">
                  <span>Page ${curPage1 + 1}</span>
                  <svg class="search__icon">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-arrow-right"></use>
                  </svg>
          </button>
      `;
        // Last Page
        if (curPage1 === numPages && numPages > 1) return `
      <button data-goto="${curPage1 - 1}" class="btn--inline pagination__btn--prev">
              <svg class="search__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-arrow-left"></use>
              </svg>
              <span>Page ${curPage1 - 1}</span>
       </button>
      `;
        // Other Pages(no first , no last)
        if (curPage1 < numPages) return `
      <button data-goto="${curPage1 - 1}" class="btn--inline pagination__btn--prev">
              <svg class="search__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-arrow-left"></use>
              </svg>
              <span>Page ${curPage1 - 1}</span>
       </button>
       <button data-goto="${curPage1 + 1}" class="btn--inline pagination__btn--next">
                  <span>Page ${curPage1 + 1}</span>
                  <svg class="search__icon">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1fdba731d27b481b$exports))}#icon-arrow-right"></use>
                  </svg>
       </button>
      `;
        // Page 1 , there are no other Pages
        return "";
    }
}
var $f03ebf78cca01ded$export$2e2bcd8739ae039 = new $f03ebf78cca01ded$var$PaginationView();



const $cdc8bba1cf7e6fe0$var$controlRecipes = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).renderSpinner();
        // 0. Update result view to mark selected search results
        (0, $99e6646170dcffc3$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$8c2e2ac0b8a4e1c4());
        // 1. Updating Bookmark View
        (0, $6346fa8b18afb025$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
        // 2. Loading Recipe
        await $0bc36518f6cf0450$export$b96725c7a035d60b(id);
        // 3. Rendering Recipe
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).renderError();
        console.log(err);
    }
};
const $cdc8bba1cf7e6fe0$var$controlSearchResults = async function() {
    try {
        (0, $99e6646170dcffc3$export$2e2bcd8739ae039).renderSpinner();
        // 1. Get Search Query
        const query = (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        // 2. Load Search Results
        await $0bc36518f6cf0450$export$202b8e5cb363a0c4(query);
        // 3. Render Search Results
        (0, $99e6646170dcffc3$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$8c2e2ac0b8a4e1c4());
        // 4. Render Pagination
        (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.search);
    } catch (err) {
        console.log(err);
    }
};
const $cdc8bba1cf7e6fe0$var$controlPagination = function(goToPage) {
    // 1. Render New Search Results
    (0, $99e6646170dcffc3$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$8c2e2ac0b8a4e1c4(goToPage));
    // 2. Render New Pagination
    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.search);
};
const $cdc8bba1cf7e6fe0$var$controlServing = function(newServings) {
    //Update recipe servings
    $0bc36518f6cf0450$export$43630f7a3a617b54(newServings);
    //Update the recipe View
    // recipeView.render(model.state.recipe);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
};
const $cdc8bba1cf7e6fe0$var$controlBookmark = function() {
    // 1. Add/Remove bookmark
    if ($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked) $0bc36518f6cf0450$export$2db69b245b3902c8($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id);
    else $0bc36518f6cf0450$export$72009cc673d27d80($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    // 2. Update Recipe View
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    // 3. Render Bookmark View
    (0, $6346fa8b18afb025$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
};
const $cdc8bba1cf7e6fe0$var$controlBookmarks = function() {
    (0, $6346fa8b18afb025$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
};
const $cdc8bba1cf7e6fe0$var$controlAddRecipe = async function(newRecipe) {
    try {
        // Add Spinner
        (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderSpinner();
        // Upload New recipe data
        await $0bc36518f6cf0450$export$d660c2254e74960d(newRecipe);
        console.log($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
        // Render recipe
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
        // Render Massage
        (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderMessage();
        // Render bookmark View
        (0, $6346fa8b18afb025$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
        // Change id in URL
        window.history.pushState(null, "", `#${$0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id}`);
        // Closing Form window
        setTimeout(function() {
            (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $a536fbf06af412b5$export$3ce8858248d89a69) * 1000);
    } catch (err) {
        console.error(err, "\uD83D\uDE00\uD83D\uDE00\uD83D\uDE00");
        (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderError(err.message);
    }
};
const $cdc8bba1cf7e6fe0$var$init = function() {
    (0, $6346fa8b18afb025$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlBookmarks);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlRecipes);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerUpdateServings($cdc8bba1cf7e6fe0$var$controlServing);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerBookmark($cdc8bba1cf7e6fe0$var$controlBookmark);
    (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).addHandlerSearch($cdc8bba1cf7e6fe0$var$controlSearchResults);
    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlPagination);
    (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).addHandlerUpload($cdc8bba1cf7e6fe0$var$controlAddRecipe);
};
$cdc8bba1cf7e6fe0$var$init();

})();
//# sourceMappingURL=index.4c293e6a.js.map
